<script setup>
import { ref, computed, onMounted, onUpdated, onUnmounted, nextTick } from 'vue'

const props = defineProps({
  showScroll: {
    type: Boolean,
    required: true
  },
})

const scrollable = ref(null)
const needsScrolling = ref(false)

const showArrows = computed(() => props.showScroll && needsScrolling.value)

function checkScrollNeeded() {
  if (scrollable.value) {
    needsScrolling.value = scrollable.value.scrollWidth > scrollable.value.clientWidth
  }
}

function scrollLeft() {
  if (scrollable.value) {
    const firstCard = scrollable.value.querySelector('.scrollable-card')
    if (firstCard) {
      scrollable.value.scrollLeft -= firstCard.offsetWidth + parseFloat(getComputedStyle(firstCard).marginRight) + 24 // 24 is = space-x-6 class on the container
    }
  }
}

function scrollRight() {
  if (scrollable.value) {
    const firstCard = scrollable.value.querySelector('.scrollable-card')
    if (firstCard) {
      scrollable.value.scrollLeft += firstCard.offsetWidth + parseFloat(getComputedStyle(firstCard).marginRight) + 24 // 24 is = space-x-6 class on the container
    }
  }
}

onMounted(() => {
  nextTick(() => {
    checkScrollNeeded()
    window.addEventListener('resize', checkScrollNeeded)
  })
})

onUpdated(() => {
  nextTick(() => {
    checkScrollNeeded()
  })
})

onUnmounted(() => {
  window.removeEventListener('resize', checkScrollNeeded)
})
</script>

<template>
  <div class="relative">
    <div class="flex flex-col space-y-4 sm:flex-row sm:overflow-x-scroll sm:space-y-0 sm:space-x-6 px-1 py-2 pb-8 no-scrollbar scroll-smooth relative sm:ml-[64px] sm:mr-[64px]"
         ref="scrollable">
      <slot></slot>
    </div>
    <button @click="scrollLeft" v-if="showArrows"
            class="hidden sm:block absolute left-0 top-[35px] h-[100px] arrow-container text-white rounded-xl opacity-75 hover:opacity-100">
      <img src="../assets/icons/chevron_left_40dp_FILL0_wght400_GRAD0_opsz40.svg" alt="Logo 1" class="h-[50px]">
    </button>

    <button @click="scrollRight" v-if="showArrows"
            class="hidden sm:block absolute right-0 top-[35px] h-[100px] arrow-container rounded-xl opacity-75 hover:opacity-100">
      <img src="../assets/icons/chevron_left_40dp_FILL0_wght400_GRAD0_opsz40.svg" alt="Logo 1"
           class="h-[50px] transform rotate-180">
    </button>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/components/scrollable';
</style>
